import { useEffect, useMemo, type ReactNode } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { getAuthToken } from '~/API/externals'
import { buildCommonParams, buildRequestOptions, type HostType } from './api'
import {
    APIConfigContext,
    type APIConfigContextValue,
} from './APIConfigContext'
import { getQueryClient } from './'

interface APIQueryProviderProps {
    children: ReactNode
}

export const APIQueryProvider = ({ children }: APIQueryProviderProps) => {
    const authToken = getAuthToken()

    const config = useMemo<APIConfigContextValue>(() => {
        const commonParams = buildCommonParams()

        const getRequestOptionsForHost = (hostType: HostType) => {
            return buildRequestOptions(hostType, authToken)
        }

        return {
            commonParams,
            getRequestOptionsForHost,
        }
    }, [authToken])

    // Invalidate all queries when auth token changes (e.g., login/logout)
    useEffect(() => {
        const queryClient = getQueryClient()
        queryClient.invalidateQueries()
    }, [authToken])

    return (
        <QueryClientProvider client={getQueryClient()}>
            <APIConfigContext.Provider value={config}>
                {children}
            </APIConfigContext.Provider>
        </QueryClientProvider>
    )
}
